module.exports = __webpack_public_path__ + "img/torus@3x.6cf9b388.png";